<template>
    <a
        class="related-bundle-card"
        :class="`related-bundle-card--${variant}`"
        :href="product.product_details_url"
    >
        <div class="related-bundle-card__image">
            <img
                :src="product.images"
                alt=""
            />
            <span
                v-if="options.showFavorite"
                class="related-bundle-card__favorite"
                :class="{ 'is-favorited': product.favorited }"
                @click.stop.prevent="$emit('favorite', product)"
            >
                <i :class="product.favorited ? 'icon-favoritefilled' : 'icon-favorite'"></i>
            </span>
            <!-- A bundle's "+" opens its PDP, same as the catalog: components are picked there. -->
            <span
                v-if="variant === 'grid'"
                class="related-bundle-card__add theme-primary-color"
            >
                <span class="related-bundle-card__add-plus">+</span>
                <span class="related-bundle-card__add-text">{{ options.addLabel }}</span>
            </span>
        </div>
        <div class="related-bundle-card__details">
            <div class="related-bundle-card__title">
                <div class="related-bundle-card__labels">
                    <span class="bundle-badge">{{ options.bundleLabel }}</span>
                    <span class="related-bundle-card__sku">{{ product.sku }}</span>
                </div>
                <div class="related-bundle-card__name">{{ product.name }}</div>
            </div>
            <bo-price-display
                v-if="priceDisplay"
                :size="variant === 'grid' ? 'medium' : 'small'"
                v-bind="priceDisplay"
            ></bo-price-display>
        </div>
        <span
            v-if="variant === 'list'"
            class="related-bundle-card__add theme-primary-color"
            >+</span
        >
    </a>
</template>

<script>
import BoPriceDisplay from "js/frontend/components/bo-price-display.vue";
import { buildCatalogPriceDisplay } from "js/frontend/utils/catalog-price-display.js";

// One bundle in the PDP "Also Available As" section or modal. The whole card links to the bundle's PDP.
export default {
    components: { BoPriceDisplay },

    props: {
        product: {
            type: Object,
            required: true,
        },
        // sidebar | row (PDP section) · grid | list (modal, desktop | mobile)
        variant: {
            type: String,
            default: "sidebar",
        },
        // { priceOptions (null hides the price), showFavorite, bundleLabel, addLabel }
        options: {
            type: Object,
            required: true,
        },
    },

    computed: {
        priceDisplay() {
            if (!this.options.priceOptions) {
                return null;
            }

            return { ...buildCatalogPriceDisplay(this.product, this.options.priceOptions), showPoint: false };
        },
    },
};
</script>
